/*
 * @Author: DingNanLin 1981261270@qq.com
 * @Date: 2025-05-20 15:32:03
 * @LastEditors: DingNanLin 1981261270@qq.com
 * @LastEditTime: 2025-08-14 16:59:12
 * @FilePath: \dfec-web-clid:\项目模板\后台管理系统模板\vue3\vue3-vite-templant\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue'
import App from './App.vue'
// 引入路由管理
import { setupRouter } from '@/router'
// 引入状态管理
import { setupStore } from '@/store/index.ts'
// 引入全局scss
import '@/styles/index.scss'
// 引入elementPlus
import { setupElementPlus } from '@/plugins/elementPlus'
// 引入svgIcon
import { setupSvgIcon } from '@/plugins/svgIcon'
// 引入自定义指令
import { setupDirectivesTools } from '@/plugins/directivesTool'
// ↓ 替换为手动调用
import setupPermission from './permission'

const app = createApp(App)

const setupAll = async () => {
    setupStore(app)
    setupPermission()
    setupDirectivesTools(app)
    setupRouter(app)
    setupElementPlus(app)
    setupSvgIcon(app)
}
setupAll().then(() => {
    app.mount('#app')
})
